import { IButtonStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, Sizes, Transitions } from '../../themes/styles';

export const iconButtonStylesDefault = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    width: 20,
    height: 20,
    backgroundColor: theme.semanticColors?.bodyBackground,
    borderRadius: Sizes.borderRadius,
  },
  icon: {
    color: theme.semanticColors?.textPrimary,
    fontSize: FontSizes.xxsmall,
  },
});

export const iconButtonStylesNoBG: IButtonStyles = {
  root: {
    backgroundColor: 'transparent',
    '&.rotate90': {
      '.ms-Icon': {
        transform: 'rotate(90deg)',
      },
    },
  },
  icon: {
    fontSize: FontSizes.xsmall,
    transitionProperty: 'transform',
    transitionDuration: Transitions.short,
  },
};

export const iconButtonStylesToggle = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    backgroundColor: 'transparent',
    '&.is-checked': {
      '.ms-Icon': {
        color: theme.semanticColors?.buttonText,
      },
    },
  },
  icon: {
    fontSize: FontSizes.medium,
    height: 18,
    lineHeight: 18,
    color: theme.semanticColors?.buttonPrimaryDisabledBorder,
  },
});

export const iconButtonStylesCircle = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    backgroundColor: 'transparent',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: `1px solid ${theme.semanticColors?.buttonInlineBorder}`,
  },
  icon: {
    fontSize: FontSizes.xsmall,
  },
});

export const iconButtonStylesPrimaryBigCircle = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    border: `1px solid ${theme.semanticColors?.buttonBorder}`,
  },
  icon: {
    fontSize: FontSizes.medium,
  },
});

export const iconButtonStylesAppBar = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    backgroundColor: 'transparent',
    position: 'relative',
    width: '32px',
    height: '32px',
    '&.is-disabled': {
      backgroundColor: 'transparent',
    },
    '.beamer_icon.active': {
      display: 'inline-block',
      borderRadius: '50%',
      width: '18px',
      height: '18px',
      backgroundColor: '#ff3e43',
      position: 'absolute',
      inset: '-5px 0 0 16px',
      color: '#fff',
      fontSize: '11px',
      fontFamily: 'arial',
      textAlign: 'center',
      lineHeight: '18px',
      fontWeight: '700',
      opacity: 1,
      letterSpacing: 0,
    },
  },
  rootHovered: {
    backgroundColor: 'transparent',
  },
  rootPressed: {
    backgroundColor: 'transparent',
  },
  icon: {
    fontSize: '1.75rem',
    color: theme.semanticColors?.buttonIconColor,
  },
  iconHovered: {
    color: theme.semanticColors?.buttonGhostTextHovered,
  },
});
